var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "player-props-component",
      class: [
        {
          empty:
            ((_vm.playerProps && _vm.playerProps.length === 0) ||
              _vm.filteredPlayerPropsEventMarkets.length === 0) &&
            !_vm.isLoading
        }
      ]
    },
    [
      !_vm.isPlayerPropsEmpty
        ? _c(
            "v-expansion-panel",
            {
              staticClass: "player_props_holder",
              class: [
                {
                  withContent:
                    _vm.filteredPlayerPropsEventMarkets.length > 0 &&
                    !_vm.isLoading
                }
              ],
              model: {
                value: _vm.expansionPanel,
                callback: function($$v) {
                  _vm.expansionPanel = $$v
                },
                expression: "expansionPanel"
              }
            },
            [
              _c(
                "v-expansion-panel-content",
                {
                  class: [{ "feature-tab": _vm.isFeatureTabs }],
                  attrs: { disabled: !_vm.isCarouselMode },
                  scopedSlots: _vm._u(
                    [
                      _vm.isCarouselMode
                        ? {
                            key: "header",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "pp_header" }, [
                                  _c("div", { staticClass: "header-title" }, [
                                    _c("span", { staticClass: "pp_icon" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "pp_title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("PlayerProps.Widget.Title")
                                        )
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.isLoading && !_vm.isFeatureTabs
                                  ? _c("circle-loader")
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      staticClass: "player-props-w",
                      class: {
                        "one-player-props-only":
                          _vm.filteredPlayerPropsEventMarkets.length === 1
                      }
                    },
                    [
                      _vm._l(_vm.filteredPlayerPropsEventMarkets, function(
                        event
                      ) {
                        return _c(
                          "div",
                          {
                            key: event.idfoevent,
                            staticClass: "props-wrapper",
                            class: [
                              {
                                "one-props-only":
                                  _vm.filteredPlayerPropsEventMarkets.length ===
                                  1
                              }
                            ],
                            attrs: { "data-eid": event.idfoevent }
                          },
                          [
                            _c("player-props-widget", {
                              attrs: {
                                event: event,
                                competitions: _vm.competitions,
                                oneEvent:
                                  _vm.filteredPlayerPropsEventMarkets.length ===
                                  1
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      !_vm.isLoading && _vm.isPlayerPropsEmpty
                        ? _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("PlayerProps.Widget.EmptyResponse"))
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      ((_vm.playerProps && _vm.playerProps.length === 0) ||
        _vm.filteredPlayerPropsEventMarkets.length === 0) &&
      !_vm.isLoading
        ? _c("div", { staticClass: "no-available-props" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("PlayerProps.Widget.EmptyResponse")))
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06014518", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06014518","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/playerPropsWidget/PlayerPropsWidgetComponent.vue
// module id = null
// module chunks = 